import { Select, Label, SelectProps } from "flowbite-react";
import { forwardRef } from "react";

interface CustomSelectProps extends SelectProps {
  id?: string;
  label: string;
  options: { value: string; label: string }[];
  error?: string;
}

const CustomSelect = forwardRef<HTMLSelectElement, CustomSelectProps>(
  ({ id, label, options, error, ...props }, ref) => {
    return (
      <div className="mb-4">
        <Label htmlFor={id}>{label}</Label>
        <Select id={id} ref={ref} {...props}>
          <option value="" disabled>
            Select {label.toLowerCase()}
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
        {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
      </div>
    );
  },
);

CustomSelect.displayName = "CustomSelect";

export default CustomSelect;
